/**
 * HttpHelper Service
 * @exports HttpHelper/Service
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { ToastrService } from 'ngx-toastr';
@Injectable()

/**
 * @class
 * HttpHelper Service
 */
export class HttpHelperService {


  /**
   * Constructor of this class
   */
  constructor(
    public router: Router,
    private toastr: ToastrService
     ) { }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  public handleError<T>(operation = 'operation', result?: any) {
    return (error: any): Observable<any> => {
      if ( error.status === 0 ) {
        this.toastr.error('Unable to connect to the server as a network error has occurred. Please try again later.');
      } else if (error.status === 302) {
        alert();
        this.router.navigateByUrl(error.error.redirectUrl);
        result = {};
      }
      return of(result as T);
    };
  }
}
